import { MainLayout } from 'layouts'
import { LkmDocumentsList } from './components/LkmDocumentsList'

export function LkmDocumentsPage() {
  return (
    <MainLayout>
      <div className='container'>
        <h1>Сертификаты</h1>
        <LkmDocumentsList />
      </div>
    </MainLayout>
  )
}
